import axios from 'axios'

export const api = axios

export const onboardingApi = axios.create({
  baseURL: `${process.env.REACT_APP_ONBOARDING_API}/api/v1/`,
})
